<template>
  <el-dialog
    title="相关程序版本"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="60%"
    top="5%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="toolbar" style="margin-top: -20px">
      <el-button
        type="primary"
        @click="onCreateClick()"
        v-permission="'dci_version_manage-*'"
      >
        <i class="fas fa-plus"></i> 新增相关程序版本
      </el-button>
    </div>
    <el-table :data="itemList" v-loading="loading" style="margin-bottom: 10px">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column
        prop="DciPvSoftware.DciPvSoftwareClassify.ClassName"
        label="程序分类名称"
      />
      <el-table-column prop="DciPvSoftware.SoftwareName" label="应用程序" />
      <el-table-column
        prop="VersionName"
        label="版本号"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.VersionName }}
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.DownloadUrl !== ''"
          >
            <div slot="content">下载地址:<br />{{ scope.row.DownloadUrl }}</div>
            <i
              class="fas fa-clone"
              style="color: #67c23a; cursor: pointer"
              v-clipboard="scope.row.DownloadUrl"
              v-clipboard:success="onSuccess"
              v-clipboard:error="onError"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发布日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.PublishAt">
            {{ $sys.dateFormat(scope.row.PublishAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="success"
            @click.stop="onDownload(scope.row)"
            title="下载"
            :disabled="scope.row.DownloadUrl === ''"
          >
            <i class="fas fa-download"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            v-permission="'dci_version_manage-*'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
    </div>

    <el-dialog
      title="新增相关程序版本"
      :visible.sync="configVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="configVisible = false"
      width="30%"
    >
      <el-form
        ref="configItemForm"
        label-width="120px"
        :model="configItem"
        :rules="rules"
      >
        <el-form-item label="程序分类名称" prop="DciPvSoftwareClassifyID">
          <select2
            style="width: 100%"
            labelName="ClassName"
            v-model="configItem.DciPvSoftwareClassifyID"
            url="dci/pv/softwareClassify?order=class_name"
            :clearable="false"
            placeholder="请选择程序分类名称"
            no-data-text="没有程序分类名称"
            :queryOne="false"
          ></select2>
        </el-form-item>
        <el-form-item label="应用程序" prop="DciPvSoftwareID">
          <select2
            style="width: 100%"
            labelName="SoftwareName"
            v-model="configItem.DciPvSoftwareID"
            :url="softwareUrl"
            :clearable="false"
            placeholder="请选择应用程序"
            no-data-text="无应用程序"
            :disabled="!configItem.DciPvSoftwareClassifyID"
            :queryOne="false"
          ></select2>
        </el-form-item>
        <el-form-item label="版本号" prop="DciPvSoftwareVersionID">
          <el-select
            v-model="configItem.DciPvSoftwareVersionID"
            filterable
            allow-create
            default-first-option
            :clearable="false"
            placeholder="请选择版本号"
            style="width: 100%"
            :disabled="!configItem.DciPvSoftwareID"
          >
            <el-option
              v-for="version in versionList"
              :key="version.ID"
              :label="version.VersionName"
              :value="version.ID"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="configVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          @click="onCreateConfim"
          :disabled="submitting"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value), //文件系统版本
      itemList: [], //相关程序版本
      loading: false,
      submitting: false,
      configVisible: false,
      configItem: {
        DciPvSoftwareClassifyID: "", //程序分类名称id
        DciPvSoftwareID: "", //应用程序id
        DciPvSoftwareVersionID: "", //版本号id
      },
      rules: {
        DciPvSoftwareClassifyID: [
          { required: true, message: "程序分类名称不能为空", trigger: "blur" },
        ],
        DciPvSoftwareID: [
          { required: true, message: "应用程序不能为空", trigger: "blur" },
        ],
        DciPvSoftwareVersionID: [
          { required: true, message: "版本号不能为空", trigger: "blur" },
        ],
      },
      softwareUrl: "",
      versionUrl: "",
      versionList: [], //相关程序版本
    };
  },
  watch: {
    "configItem.DciPvSoftwareClassifyID": {
      handler() {
        this.softwareUrl = `dci/pv/software?order=software_name&where[DciPvSoftwareClassifyID]=${this.configItem.DciPvSoftwareClassifyID}`;
      },
    },
    "configItem.DciPvSoftwareID": {
      handler() {
        this.versionUrl = `dci/pv/softwareversion?order=-publish_at&where[DciPvSoftwareID]=${this.configItem.DciPvSoftwareID}`;
        this.$axios
          .get(this.versionUrl)
          .then((response) => {
            this.versionList = response.data.data;
            if (this.versionList != null && this.versionList.length > 0) {
              this.configItem.DciPvSoftwareVersionID = this.versionList[0].ID;
            }
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          })
          .finally(() => {});
      },
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.getList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.itemList = [];
    },

    getList() {
      this.loading = true;
      this.$axios
        .get(`dci/pv/productversion/${this.item.ID}`)
        .then((response) => {
          this.itemList = response.data.DciPvSoftwareVersions;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //点击新增相关版本按钮
    onCreateClick() {
      this.configVisible = true;
      this.configItem.DciPvSoftwareClassifyID = "";
      this.configItem.DciPvSoftwareID = "";
      this.configItem.DciPvSoftwareVersionID = "";
    },
    onCreateConfim() {
      this.$refs.configItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$axios
          .request({
            url: "dci/pv/productversion/softwareversion",
            method: "post",
            data: {
              DciPvProductVersionID: this.item.ID,
              DciPvSoftwareVersionID: this.configItem.DciPvSoftwareVersionID,
            },
          })
          .then(() => {
            this.submitting = false;
            this.configVisible = false;
            this.getList();
            this.$message.success("新增成功");
          })
          .catch(({ response }) => {
            this.submitting = false;
            this.$sys.alarmResponse(response);
          });
      });
    },

    //下载
    async onDownload(row) {
      const { data } = await this.$axios({
        url: row.DownloadUrl,
        responseType: "blob",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });
      const blob = new Blob([data], {
        type: "application/*;chartset=UTF-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      let filename = row.VersionName;
      if (row.DownloadUrl.indexOf("/") !== -1) {
        const arr = row.DownloadUrl.split("/");
        filename = arr[arr.length - 1];
      }

      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },

    //删除相关程序版本
    onDeleteItem(row) {
      this.$confirm("确定要删除此关联的程序版本吗？", "提示")
        .then(() =>
          this.$axios.request({
            url: "dci/pv/productversion/softwareversion",
            method: "delete",
            data: {
              DciPvProductVersionID: this.item.ID,
              DciPvSoftwareVersionID: row.ID,
            },
          })
        )
        .then(() => {
          this.getList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    onSuccess() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.success("复制失败");
    },
  },
};
</script>

